// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3ZYpN","row":"Node_row__1A0dF","label":"Node_label__tjwpJ","footer":"Node_footer__2PvQo"};